import { SubmitModalProps } from '@healthnz-prm/fhir-engine-renderer/types'
import { Button } from '@/components/ui/button'
import { BaseModal } from '@/components/shared/baseModal'
import { useSubmitState } from '@/contexts/submitState/submitState'
import { useEmbed } from '@/contexts/embed/embed'

const defaultSubmitButton = 'Submit response'
const defaultTitle = 'Submit questionnaire response'

export function SubmitModal({
  children,
  onClose,
  onSubmit,
  submitButtonLabel,
  title
}: SubmitModalProps) {
  const { changeSubmitState, submitState } = useSubmitState()
  const { onPageChange } = useEmbed()

  const handleSubmit =
    onSubmit &&
    (async () => {
      onPageChange() // page changes to loading
      changeSubmitState('loading')

      onSubmit().then((res: string) => {
        onPageChange() // page changes to post-submit or back to final page
        switch (res) {
          case 'error':
            // TODO: handle errors
            return changeSubmitState('ready')
          case 'invalid':
            return changeSubmitState('ready')
          case 'success':
            return changeSubmitState('success')
          default:
            return changeSubmitState('ready')
        }
      })
    })

  const handleOnConfirm = () => {
    handleSubmit?.()
    onClose()
  }

  return (
    <BaseModal
      onClose={onClose}
      title={title || submitButtonLabel || defaultTitle}
    >
      <div>
        <div className='space-y-2'>{children}</div>

        <div className='flex flex-col items-center'>
          <Button
            className='mt-12'
            size='xl'
            onClick={handleOnConfirm}
            disabled={submitState === 'loading'}
            variant='default'
          >
            {`Yes, ${(
              submitButtonLabel ||
              title ||
              defaultSubmitButton
            ).toLowerCase()}`}
          </Button>

          <Button
            size='xl'
            className='mt-4'
            onClick={onClose}
            variant='secondary'
          >
            No, back to form
          </Button>
        </div>
      </div>
    </BaseModal>
  )
}
